<template>
  <div
    @click="goNext"
    class="index animated fadeIn"
    v-bind:style="{ backgroundImage: 'url(' + bg_img + ')' }"
  >
    <h3 ref="title" class="title animated bounceInLeft"><span>品牌故事</span></h3>
    <h3 ref="name" class="animated fadeInRight">享你所想，住你喜欢</h3>
    <div class="us-item">
      <img
        ref="img"
        class="index-bottom animated fadeInLeft"
        src="https://cdn.hanlandglobal.com/h5-story-bg.png"
      />
      <p ref="content" class="animated fadeIn">
        游梓公寓（UZILiving）团队不断拓展英国公寓资源，丰富产品线，提供更多样的学生公寓，民宿，酒店式公寓和接机业务，兢兢业业，砥砺前行。游梓公寓一贯秉持“享你所想，住你喜欢”的主张，为让独在异乡的海外游子们的生活变得更加舒适和便捷而努力。
      </p>
    </div>
    <img ref="gif" class="gif-img animated fadeIn" :src="gif" />
  </div>
</template>

<script>
// @ is an alias to /src
import bg_img from '../assets/image/h5-bg.png';
import button_img from '../assets/image/button-bg.png';
import gif from '../assets/image/shouzhi.gif';

export default {
  name: 'Home',
  data() {
    return {
      bg_img,
      button_img,
      gif,
    };
  },
  mounted() {},
  methods: {
    goNext: function() {
      this.$refs.img.className = 'index-bottom animated fadeOutLeft';
      this.$refs.content.className = 'animated fadeOutRight';
      this.$refs.name.className = 'animated fadeOutRight';
      this.$refs.title.className = 'title animated fadeOutRight';
      this.$refs.gif.className = 'gif-img gif animated fadeOut';
      setTimeout(() => {
        this.$router.push('/growUp');
      }, 600);
    },
  },
};
</script>
<style lang="scss" scoped>
.index {
  width: 100vw;
  height: 100vh;
  background-repeat: no-repeat;
  background-size: 100% 100vh;
  position: relative;
}
.title {
  padding-top: 13.6vh;
  margin-bottom: 0.2rem;
}
h3 {
  font-size: 0.45rem;
  font-weight: 700;
  font-family: SourceHan;
  color: #4d372e;
  text-align: center;
  letter-spacing: 1px;
  text-align: right;
  margin-right: 0.6rem;
  span {
    font-size: 0.72rem;
  }
}
.index-bottom {
  width: 7.44rem;
  height: 4.48rem;
  position: absolute;
  left: -4rem;
  bottom: 0;
}
.us-item {
  p {
    width: 3.2rem;
    font-size: 0.28rem;
    font-stretch: normal;
    text-align: left;
    letter-spacing: 1px;
    color: #543f3c;
    position: absolute;
    line-height: 0.56rem;
    right: 0.3rem;
    margin-top: 0.8rem;
    // bottom:3.2rem;
  }
}
.gif-img {
  position: absolute;
  width: 2.7rem;
  height: 1.98rem;
  z-index: 999;
  bottom: 0.2rem;
  right: 0.2rem;
  animation-delay: 0.8s;
}
.gif {
  animation-delay: 0s;
}
</style>
